import { createLazyComponent, LazyModule, LazyAction } from 'owa-bundling';

const lazyModule = new LazyModule(() => import(/* webpackChunkName: "QuickUse" */ './lazyIndex'));

export { QuickUseViewState } from './store/schema/QuickUseViewState';

export let initializeQuickUseCopyPasteListenerLazy = new LazyAction(
    lazyModule,
    m => m.initializeQuickUseCopyPasteListener
);
export let initializeQuickUseDataLazy = new LazyAction(lazyModule, m => m.initializeQuickUseData);
export let logQuickUseButtonClickedDatapointLazy = new LazyAction(
    lazyModule,
    m => m.logQuickUseButtonClickedDatapoint
);
export let QuickUseCalloutLazy = createLazyComponent(lazyModule, m => m.QuickUseCallout);
export let QuickUseIndicatorCalloutLazy = createLazyComponent(
    lazyModule,
    m => m.QuickUseIndicatorCallout
);
